import { render, staticRenderFns } from "./FreeNewsroomLanding2.vue?vue&type=template&id=f537c4ca"
import script from "./FreeNewsroomLanding2.vue?vue&type=script&lang=js"
export * from "./FreeNewsroomLanding2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports